
import { defineComponent, computed, onMounted, onUnmounted, ref, watch } from 'vue';
// import Main from "../components/Main.vue";
import UserInfo from "../components/UserInfo.vue";
import Logo from "../components/Logo.vue";
import DiskInfo from "../components/DiskInfo.vue";
import DicomFileUpload from "../components/DicomFileUpload.vue";
import DicomOption from "../components/DicomOption.vue";
import DicomWebViewer from "../components/DicomWebViewer.vue";
import ExportPopup from "../components/popup/ExportPopup.vue";
import PacsPopup from "../components/popup/PacsPopup.vue";
import PacsSettingPopup from "../components/popup/PacsSettingPopup.vue";
import ResultListPopup from "../components/popup/ResultListPopup.vue";
import LogoutAlertPopup from "../components/popup/LogoutAlertPopup.vue";
import DeleteConfirmPopup from "../components/popup/DeleteConfirmPopup.vue";
import DeleteDicomListConfirmPopup from "../components/popup/DeleteDicomListConfirmPopup.vue";
import CompleteScoreSavePopup from "../components/popup/CompleteScoreSavePopup.vue";
import DicomTagPopup from "../components/popup/DicomTagPopup.vue";
import DuplicationPopup from "../components/popup/DuplicationPopup.vue";
import DiskFullPopup from "../components/popup/DiskFullPopup.vue";
import SessionConflictPopup from "../components/popup/SessionConflictPopup.vue";
import NowUploadPopup from "../components/popup/NowUploadPopup.vue";
import NowConnectPopup from "../components/popup/NowConnectPopup.vue";
import { useRouter } from 'vue-router';
import { useLoginStore } from '@/store/login'
import { useUsersStore } from '@/store/users'
import { useDicomStore } from '@/store/dicom'
import { usePopupStore } from '@/store/popup'
import { useViewerStore } from '@/store/viewer'
import { useReadingResultStore } from '@/store/readingResult'

export default defineComponent({
  components: {
    Logo,
    DicomFileUpload,
    DicomOption,
    ExportPopup,
    PacsPopup,
    PacsSettingPopup,
    ResultListPopup,
    LogoutAlertPopup,
    DeleteConfirmPopup,
    DeleteDicomListConfirmPopup,
    CompleteScoreSavePopup,
    DicomTagPopup,
    DuplicationPopup,
    DiskInfo,
    DiskFullPopup,
    DicomWebViewer,
    SessionConflictPopup,
    NowUploadPopup,
    NowConnectPopup
  },
  setup() {
    const router = useRouter();
    const dicomStore = useDicomStore();
    const usersStore = useUsersStore();
    const popupStore = usePopupStore();
    const viewerStore = useViewerStore();
    const readingResultStore = useReadingResultStore();
    const loginUser = computed(() => useUsersStore().getLoginUser);
    const exportPopupIsOpen = computed(() => popupStore.getIsOpen('export'));
    const pacsPopupIsOpen = computed(() => popupStore.getIsOpen('pacs'));
    const pacsSettingPopupIsOpen = computed(() => popupStore.getIsOpen('pacsSetting'));
    const resultListPopupIsOpen = computed(() => popupStore.getIsOpen('resultList'));
    const logoutAlertPopupIsOpen = computed(() => popupStore.getIsOpen('logoutAlert'));
    const deleteConfirmPopupIsOpen = computed(() => popupStore.getIsOpen('deleteConfirm'));
    const deleteDicomConfirmPopupIsOpen = computed(() => popupStore.getIsOpen('deleteDicomConfirm'));
    const completeScorePopupIsOpen = computed(() => popupStore.getIsOpen('completeScore'));
    const dicomTagPopupIsOpen = computed(() => popupStore.getIsOpen('dicomTag'));
    const duplicationPopupIsOpen = computed(() => popupStore.getIsOpen('duplication'));
    const diskPopupIsOpen = computed(() => popupStore.getIsOpen('disk'));
    const sessionConflictPopupIsOpen = computed(() => popupStore.getIsOpen('sessionConflict'));
    const nowLoadingPopupIsOpen = computed(() => popupStore.getIsOpen('nowLoading'));
    const nowConnectPopupIsOpen = computed(() => popupStore.getIsOpen('nowConnect'));
    const toggleLeft = computed(() => viewerStore.getToggleLeftState);
    const toggleRight = computed(() => viewerStore.getToggleRightState);
    const withCAD = computed(() => usersStore.getWithCAD);

    const toggleLeftPanel = () => {
      viewerStore.setToggleLeftState(!toggleLeft.value);
    }

    const toggleRightPanel = () => {
      viewerStore.setToggleRightState(!toggleRight.value);
    }

    let isReloading = false;

    const beforeUnloadHandler = () => {
      isReloading = true;
    };

    const unloadHandler = async () => {
      const manualLogout = localStorage.getItem("manualLogout");

      if (!isReloading && !manualLogout) {
        try {
          await useLoginStore().logout();
        } catch (e) {
          console.error("자동 로그아웃 실패", e);
        }
      }
    };

    const logout = async (): Promise<any> => {
      localStorage.setItem("manualLogout", "true");
      const res = await useLoginStore().logout();
      if (res === "Success") {
        usersStore.removeUserData();
        router.push({ name: 'login' });
      } else {
        console.log("LOGOUT FAIL");
      }
    };

    const setSingleImg = () => {
      if(!withCAD.value) {
        dicomStore.setSingleImg(true);
      } else {
        dicomStore.setSingleImg(false);
      }
    }

    watch(loginUser, (newVal) => {
      setSingleImg();
    });

    onMounted(async () => {
      localStorage.removeItem("manualLogout"); // 새로 진입 시 초기화
      popupStore.resetPopups();
      await usersStore.getUserData();
      readingResultStore.setReadingResultList();

      window.addEventListener("beforeunload", beforeUnloadHandler);
      window.addEventListener("unload", unloadHandler);
    });

    onUnmounted(() => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
      window.removeEventListener("unload", unloadHandler);
      viewerStore.setToggleLeftState(false);
      viewerStore.setToggleRightState(false);
    });


    return {
      logout,
      exportPopupIsOpen,
      pacsPopupIsOpen,
      pacsSettingPopupIsOpen,
      resultListPopupIsOpen,
      logoutAlertPopupIsOpen,
      deleteConfirmPopupIsOpen,
      deleteDicomConfirmPopupIsOpen,
      completeScorePopupIsOpen,
      dicomTagPopupIsOpen,
      toggleLeft,
      toggleRight,
      toggleLeftPanel,
      toggleRightPanel,
      duplicationPopupIsOpen,
      diskPopupIsOpen,
      sessionConflictPopupIsOpen,
      nowLoadingPopupIsOpen,
      nowConnectPopupIsOpen
    };
  },
});
